import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UnifiedLoginService } from '@monorepo/services';
import {
  TREQUEST_BCTX_COMPONENT_DETAILS,
  TREQUEST_CPM_ADD_TEMPLATE_LIST,
  TREQUEST_CPM_BULK_MAP_ORDER_PROCESS,
  TREQUEST_CPM_EDIT_ORDER_PROCESS,
  TREQUEST_CPM_EDIT_TEMPLATE_LIST,
  TREQUEST_CPM_GET_ORDER_DETAILS,
  TREQUEST_CPM_ORDER_LISTING,
  TREQUEST_CPM_TEMPLATE_DETAILS,
  TREQUEST_CPM_TEMPLATE_LISTING,
  TREQUEST_GET_PROCESS_CONFIGURATIONS,
  TREQUEST_GET_PROCESS_MAPPING,
  TREQUEST_UPDATE_TOGGLE_PROCESS_MAPPING,
  TRESPONSE_BCTX_COMPONENT_DETAILS,
  TRESPONSE_CPM_GET_ORDER_DETAILS,
  TRESPONSE_CPM_ORDER_LISTING,
  TRESPONSE_CPM_RESPONSE,
  TRESPONSE_CPM_TEMPLATE_DETAILS,
  TRESPONSE_CPM_TEMPLATE_LISTING,
  TRESPONSE_GET_PROCESS_CONFIGURATIONS,
  TRESPONSE_GET_PROCESS_MAPPING,
  TRESPONSE_PROCESS_MAPPING_FILTERS_SEARCH_RES,
} from '@monorepo/types';
import { of } from 'rxjs';
import { processMappingList } from './mocks';
import { ProcessMappingEndPoint, ProcessMappingEnvProvider } from './process-mapping.env.provider';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ProcessMappingDataProvider {
  constructor(
    private http: HttpClient,
    private processMappingEnvProvider: ProcessMappingEnvProvider,
    public unifiedLoginService: UnifiedLoginService,
  ) {}

  fetchProcessMappingListData(payload: TREQUEST_GET_PROCESS_MAPPING) {
    console.log('fetchProcessMappingList', payload);
    const { factoryId } = this.unifiedLoginService.getUserInfo();
    const url = this.processMappingEnvProvider.getUrlFromEnv('GET_PROCESS_MAPPING').replace(':factoryId', factoryId);
    return this.http.post<TRESPONSE_GET_PROCESS_MAPPING>(url, payload);
  }

  updateWashingStatus(payload: TREQUEST_UPDATE_TOGGLE_PROCESS_MAPPING) {
    console.log('updateWashingStatus', payload);
    const { factoryId } = this.unifiedLoginService.getUserInfo();
    const url = this.processMappingEnvProvider.getUrlFromEnv('UPDATE_WASHING_STATUS').replace(':factoryId', factoryId);
    return this.http.post(url, payload);
    // return of({});
  }

  getFiltersSearchResults(endPoint: keyof typeof ProcessMappingEndPoint, payload: any) {
    console.log('getFiltersSearchResults', payload);
    const { factoryId } = this.unifiedLoginService.getUserInfo();
    const url = this.processMappingEnvProvider.getUrlFromEnv(endPoint).replace(':factoryId', factoryId);
    return endPoint === 'SEARCH_CMP_ORDER_LIST'
      ? this.http.post<TRESPONSE_CPM_RESPONSE<TRESPONSE_PROCESS_MAPPING_FILTERS_SEARCH_RES>>(url, payload)
      : this.http
          .post<TRESPONSE_PROCESS_MAPPING_FILTERS_SEARCH_RES>(url, payload)
          .pipe(map((response) => ({ responseStatus: 'SUCCESS', response: response })));
    // return of({ searchResultItems: ['buyer3', 'buyer4'] });
  }
  fetchCPMOrderListData(payload: TREQUEST_CPM_ORDER_LISTING) {
    console.log('fetchCPMOrderListData', payload);
    const url = this.processMappingEnvProvider.getUrlFromEnv('GET_CPM_ORDER_LIST');
    return this.http.post<TRESPONSE_CPM_RESPONSE<TRESPONSE_CPM_ORDER_LISTING>>(url, payload);
  }
  fetchCPMTemplateListData(payload: TREQUEST_CPM_TEMPLATE_LISTING) {
    console.log('fetchCPMTemplateListData', payload);
    const url = this.processMappingEnvProvider.getUrlFromEnv('GET_CPM_TEMPLATE_LIST');
    return this.http.post<TRESPONSE_CPM_RESPONSE<TRESPONSE_CPM_TEMPLATE_LISTING>>(url, payload);
  }
  fetchCPMTemplateDetail(payload: TREQUEST_CPM_TEMPLATE_DETAILS) {
    console.log('fetchCPMTemplateDetail', payload);
    const url = this.processMappingEnvProvider.getUrlFromEnv('GET_CPM_TEMPLATE_DETAILS');
    return this.http.post<TRESPONSE_CPM_RESPONSE<TRESPONSE_CPM_TEMPLATE_DETAILS>>(url, payload);
  }
  fetchCPMOrderDetail(payload: TREQUEST_CPM_GET_ORDER_DETAILS) {
    console.log('fetchCPMOrderDetail', payload);
    const url = this.processMappingEnvProvider.getUrlFromEnv('GET_PROCESS_ORDER_DETAILS');
    return this.http.post<TRESPONSE_CPM_RESPONSE<TRESPONSE_CPM_GET_ORDER_DETAILS>>(url, payload);
  }
  fetchBctxComponentDetail(payload: TREQUEST_BCTX_COMPONENT_DETAILS) {
    console.log('fetchBctxComponentDetail', payload);
    const url = this.processMappingEnvProvider.getUrlFromEnv('GET_BCTX_COMPONENT_DETAILS');
    return this.http.post<TRESPONSE_BCTX_COMPONENT_DETAILS>(url, payload);
  }
  addCPMTemplateList(payload: TREQUEST_CPM_ADD_TEMPLATE_LIST) {
    console.log('addCPMTemplateList', payload);
    const url = this.processMappingEnvProvider.getUrlFromEnv('ADD_CPM_TEMPLATE_LIST');
    return this.http.post<TRESPONSE_CPM_RESPONSE<string>>(url, payload);
  }
  editCPMTemplateList(payload: TREQUEST_CPM_EDIT_TEMPLATE_LIST) {
    console.log('addCPMTemplateList', payload);
    const url = this.processMappingEnvProvider.getUrlFromEnv('EDIT_CPM_TEMPLATE_LIST');
    return this.http.post<TRESPONSE_CPM_RESPONSE<string>>(url, payload);
  }
  addCPMBulkOrderProcess(payload: TREQUEST_CPM_BULK_MAP_ORDER_PROCESS) {
    console.log('addCPMBulkOrderProcess', payload);
    const url = this.processMappingEnvProvider.getUrlFromEnv('ADD_CPM_BULK_PROCESS_ORDER');
    return this.http.post<TRESPONSE_CPM_RESPONSE<string>>(url, payload);
  }
  editCPMOrderProcess(payload: TREQUEST_CPM_EDIT_ORDER_PROCESS) {
    console.log('editCPMOrderProcess', payload);
    const url = this.processMappingEnvProvider.getUrlFromEnv('EDIT_CPM_PROCESS_ORDER');
    return this.http.post<TRESPONSE_CPM_RESPONSE<string>>(url, payload);
  }
  fetchProcessConfiguration() {
    const { factoryId } = this.unifiedLoginService.getUserInfo();
    const payload: TREQUEST_GET_PROCESS_CONFIGURATIONS = {
      subjectKey: factoryId,
    };
    console.log('fetchProcessConfiguration', payload);
    const url = this.processMappingEnvProvider.getUrlFromEnv('GET_PROCESS_CONFIGURATION');
    return this.http.post<TRESPONSE_CPM_RESPONSE<TRESPONSE_GET_PROCESS_CONFIGURATIONS>>(url, payload);
  }
}
